import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getSuppliers () {
    return Axios.get(`api/internal/clients/${this.getClientId()}/suppliers`)
  },
  addSupplier (supplier) {
    return Axios.post(`api/internal/clients/${this.getClientId()}/suppliers`, supplier)
  },
  editSupplier (supplierId, supplier) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/suppliers/${supplierId}`, supplier)
  },
  deactivateSupplier (supplierId) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/suppliers/${supplierId}/deactivate`)
  },
  activateSupplier (supplierId) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/suppliers/${supplierId}/activate`)
  },
  getItems (itemType) {
    return Axios.get(`api/internal/clients/${this.getClientId()}/service-desk/${itemType}`)
  },
  addSupplierItem (params, item) {
    return Axios.post(`api/internal/clients/${this.getClientId()}/service-desk/${params.itemType}`, item)
  },
  editSupplierItem (params, item) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/service-desk/${params.itemType}/${params.serviceId}`, item)
  },
  deactivateSupplierItem (params) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/service-desk/${params.itemType}/${params.serviceId}/deactivate`)
  },
  activateSupplierItem (params) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/service-desk/${params.itemType}/${params.serviceId}/activate`)
  },
}
